// Languages available for selection in mystique
export enum Languages {
    FR = "fr",
    EN = "en",
    ES = "es",
    RU = "ru",
    DE = "de",
    ID = "id",
    IT = "it",
    NL = "nl",
    PL = "pl",
    PT = "pt",
}

export const isLanguage = (lang: string): lang is Languages => Object.values(Languages).includes(lang as Languages);

export const supportedLanguages = Object.values(Languages);
